import { render, staticRenderFns } from "./OtoTeacherShow.vue?vue&type=template&id=5ef60f2c&scoped=true&"
import script from "./OtoTeacherShow.vue?vue&type=script&lang=js&"
export * from "./OtoTeacherShow.vue?vue&type=script&lang=js&"
import style0 from "./OtoTeacherShow.vue?vue&type=style&index=0&id=5ef60f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef60f2c",
  null
  
)

export default component.exports